import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  ITEM: '[data-fragment="FavouriteCategories.item"]',
  VIDEO_WRAPPER: '[data-fragment="FavouriteCategories.videoWrapper"]',
  VIDEO: '[data-fragment="FavouriteCategories.video"]',
};

class FavouriteCategories extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeVideo: 0,
      activeVideoPlaying: false,
    };
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.playPause = this.playPause.bind(this);
    this.handleVideoClick = this.handleVideoClick.bind(this);
    this.videoEnded = this.videoEnded.bind(this);
    this.switchVideo = this.switchVideo.bind(this);
  }
  didMount() {
    this.on('click', fragments.VIDEO_WRAPPER, this.handleVideoClick);
    this.on('mouseover', fragments.ITEM, this.switchVideo);
    this.videos = [...this.element.querySelectorAll(fragments.VIDEO)];
    for (let i = 0; i < this.videos.length; i++) {
      this.videos[i].addEventListener('ended', this.videoEnded);
      this.videos[i].dataset.id = i;
    }
    this.video_wrappers = [...this.element.querySelectorAll(fragments.VIDEO_WRAPPER)];
    this.video_wrappers[this.state.activeVideo].classList.add('active');
    this.zoomTimeout = null;
  }
  handleVideoClick = (e) => {
    this.playPause(e.currentTarget.firstElementChild);
  };
  playPause = (video) => {
    if (!video.dataset.image) {
      if (video.paused) {
        this.play(video);
      } else {
        this.pause(video);
      }
    } else {
      if (this.state.activeVideoPlaying) {
        this.pause(video);
      } else {
        this.play(video);
      }
    }
  };
  play = (video) => {
    if (!video.dataset.image) {
      video.play();
    } else {
      this.zoomTimeout = setTimeout(() => {
        this.videoEnded(video);
      }, 10000);
    }
    this.setState({
      activeVideoPlaying: true,
    });
    video.offsetParent.classList.add('playing');
    video.offsetParent.classList.remove('paused');
  };
  pause = (video, backToStart = false) => {
    if (!video.dataset.image) {
      video.pause();
      if (backToStart) {
        video.currentTime = 0;
      }
    } else {
      clearTimeout(this.zoomTimeout);
      this.zoomTimeout = null;
    }
    this.setState({
      activeVideoPlaying: false,
    });
    video.offsetParent.classList.add('paused');
    video.offsetParent.classList.remove('playing');
  };
  videoEnded = (e) => {
    clearTimeout(this.zoomTimeout);
    this.zoomTimeout = null;
    let video = null;
    if (e.type) {
      video = e.target;
    } else {
      video = e;
    }
    this.pause(video);
    for (let i = 0; i < this.video_wrappers.length; i++) {
      this.video_wrappers[i].classList.remove('active');
      const id = parseInt(video.dataset.id, 10);
      if (i === id) {
        let next = i + 1;
        if (next >= this.video_wrappers.length) {
          next = 0;
        }
        this.play(this.videos[next]);
        this.video_wrappers[next].classList.add('active');
        this.setState({
          activeVideo: next,
        });
        break;
      }
    }
  };
  switchVideo = (e) => {
    if (window.innerWidth >= 768) {
      clearTimeout(this.zoomTimeout);
      this.zoomTimeout = null;
      const id = parseInt(e.currentTarget.parentElement.querySelector(fragments.VIDEO).dataset.id, 10);
      const videoWrapper = e.currentTarget.parentElement.querySelector(fragments.VIDEO_WRAPPER);
      if (this.state.activeVideo !== id) {
        this.video_wrappers[this.state.activeVideo].classList.remove('active');
        this.pause(this.video_wrappers[this.state.activeVideo].querySelector(fragments.VIDEO), true);
        videoWrapper.classList.add('active');
        this.setState({
          activeVideo: id,
        });
      }
      this.play(videoWrapper.querySelector(fragments.VIDEO));
    }
  };
  willUnMount() {}
  update() {}
}

export default FavouriteCategories;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FavouriteCategories.js